<h3>Inbound Call Log</h3>
<form novalidate class="row g-0">
  <div class="filter mb-3 col-5 pe-1">
    <app-client-select
      [(selectedIds)]="filters.selectedClientIds"
      (changed)="onFilterChange()"
      [autoLoad]="true"
      [listFilters]="{ applicableToReferralClaims: true }"
      placeholder="Filter by Client"
      name="clientIds"/>
  </div>
  <div class="col-3 pe-1"><button class="btn btn-info clear-button" (click)="onClearClick($event)">Clear</button></div>
  <div class="col-4 text-end">
    <a routerLink="/capture-admin/communications/inbound-calls/new" class="btn btn-primary">Log Call</a>
  </div>
</form>
@if (!loading) {
  <div>
    @if (inboundCalls.length > 0) {
      <section>
        <app-pagination-header
          [label]="'inbound calls'"
          [paging]="paging"
          (pageSizeChange)="onPageSizeChange($event)"
          />
        <table class="table table-bordered table-hover">
          <thead class="table-dark">
            <tr>
              <th>CLIENT</th>
              <th>OUTCOME</th>
              <th>PATIENT</th>
              <th>PRESCRIBER</th>
              <th>CREATED AT</th>
              <th>CREATED BY</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (inboundCall of inboundCalls; track inboundCall; let i = $index) {
              <tr>
                <td>{{ inboundCall.client.humanizedName }}</td>
                <td>{{ keyedReasonOptions[inboundCall.reason].display }}</td>
                <td><app-patient-name [patient]="inboundCall.patient" /></td>
                <td><app-prescriber-name [provider]="inboundCall.provider" /></td>
                <td>{{ inboundCall.createdAt | date: 'M/d/yyyy h:mm a' }}</td>
                <td>{{ inboundCall.submittedBy.fullName }}</td>
                <td>
                  <ul class="nav">
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        routerLink="/capture-admin/communications/inbound-calls/{{inboundCall.id}}"
                        (click)="onViewClick()"
                        >
                        VIEW
                      </a>
                    </li>
                  </ul>
                </td>
              </tr>
            }
          </tbody>
        </table>
        <app-pagination [paging]="paging" (pageChange)="onPageChange($event)" />
      </section>
    } @else {
      <section><p>There are no inbound calls.</p></section>
    }
  </div>
} @else {
  <mat-spinner />
}
